module.exports = __webpack_public_path__ + "img/myneofintech_old.ad25d3a6.png";